<div [dir]="langService.languageDirection" class="lang">
    <tc-fab-wrapper></tc-fab-wrapper>
    <tc-dmc-spinner-wrapper></tc-dmc-spinner-wrapper>
    <tc-notification-toast-wrapper></tc-notification-toast-wrapper>
    <router-outlet></router-outlet>
</div>
